import React from 'react';
import retraite from './../../../../assets/images/svg/111-rocking-chair.png';
import activite from './../../../../assets/images/svg/035-id-card.svg';
import pole from './../../../../assets/images/svg/066-job-interview.svg';
import autre from './../../../../assets/images/svg/034-clipboard.svg';
import home from './../../../../assets/images/svg/069-home.svg';
import { ModalSituationPro } from './modals/modalSituationPro';
import {ProfessionOptions} from '../../../../constants/utils/connectionTypes';
export const SituationPro = ({deathDeclaration, userId, isLoading}) => {
    return (
        <section className="card mb-0 rounded-bottom-0">
            <div className="card-header pb-0">
                <div className="grid grid-md-2 align-items-center">
                    <h2 className="h4 text-uppercase text-secondary font-weight-bolder my-auto">SITUATION PROFESSIONNELLE</h2>
                    <div className="grid grid-2 ml-auto align-items-center">
                        <button type="button" data-toggle="modal" data-target="#situationProModal" className="btn btn-icon p-1 align-middle o-80 o-100--hover mx-auto"><i className="eva eva-edit-2-outline align-middle fs-lead"></i></button>
                        <div className="custom-control custom-switch mx-auto">
                            <input type="checkbox" className="custom-control-input" id="SituationProfSwitchCheckDefault" required="required"  defaultChecked={deathDeclaration.onBoardingStep > 3} />
                            <label className="custom-control-label" htmlFor="SituationProfSwitchCheckDefault">Valider</label>
                        </div>
                    </div>
                </div>
                <hr className="mb-0" />
            </div>
            <div className="card-body grid grid-xl-5">
                <div className={"block flex-row align-items-center" + (deathDeclaration.professionalSituation.includes(ProfessionOptions.active) ? "" : " o-30")}>
                    <img className="img-fluid mr-3 h-4" src={activite} alt="building" />
                    <p className="h6 text-uppercase font-weight-bold my-auto">En activite</p>
                </div>
                <div className={"block flex-row align-items-center" + (deathDeclaration.professionalSituation.includes(ProfessionOptions.retired) ? "" : " o-30")}>
                    <img className="img-fluid mr-3 h-4" src={retraite} alt="building" />
                    <p className="h6 text-uppercase font-weight-bold my-auto">RETRAITÉ(E)</p>
                </div>
                <div className={"block flex-row align-items-center" + (deathDeclaration.professionalSituation.includes(ProfessionOptions.unemployed) ? "" : " o-30")}>
                    <img className="img-fluid mr-3 h-4" src={pole} alt="building" />
                    <p className="h6 text-uppercase font-weight-bold my-auto">À FRANCE TRAVAIL</p>
                </div>                
                <div className={"block flex-row align-items-center" + (deathDeclaration.professionalSituation.includes(ProfessionOptions.other) ? "" : " o-30")}>
                    <img className="img-fluid mr-3 h-4" src={autre} alt="building" />
                    <p className="h6 text-uppercase font-weight-bold my-auto">Autre activité</p>
                </div>
                <div className={"block flex-row align-items-center" + (deathDeclaration.professionalSituation.includes(ProfessionOptions.none) ? "" : " o-30")}>
                    <img className="img-fluid mr-3 h-4" src={home} alt="building" />
                    <p className="h6 text-uppercase font-weight-bold my-auto">Sans activité</p>
                </div>

            </div>
            <ModalSituationPro deathDeclaration={deathDeclaration} isLoading={isLoading} userId={userId} />
        </section>
    )
}